import localforage from 'localforage'

// Default instance for document-related persistence
localforage.config({
  name: 'screenata-docs',
})

// Dedicated instance for chat-related persistence
export const chatLocalforage = localforage.createInstance({
  name: 'screenata-chat',
})

export default localforage
